// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kxzqjxfooqfajwttceop.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt4enFqeGZvb3FmYWp3dHRjZW9wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0NDY1NzksImV4cCI6MjA3MzAyMjU3OX0.6niA48ZvPPSGnR80fQTZyHN3a4xrM3OU1LfMwOzN8bw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});